<template>
  <div class='Box'>
    <el-card class="box-card">
      <div class="Update">
        <el-upload class="upload-demo" drag :on-change="handleChange" :show-file-list="false" ref="upload" accept=".txt"
                   :file-list="fileLists" :auto-upload="false" action="" multiple
                   style="width: 100%; display: flex; justify-content: center; align-items: center;">
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">将文件拖到此处，或<span>点击上传</span></div>
        </el-upload>
        <h2 class="upload-title" style="margin-top: 10px;">剧目名称 : <span>{{ videoName }}</span></h2>
        <div class="upload-status">

          <el-button type="primary" size="small" @click="submitBack">返回</el-button>
          <el-button type="primary" size="small" @click="submitUpload">开始上传</el-button>
          <!--<el-button type="success">基础数据</el-button>-->
          <el-tag type="success" class="item">文件数量：{{ totalFiles }}</el-tag>
          <el-tag type="warning" class="item">成功上传： {{ uploadedFiles }}</el-tag>
          <el-tag type="danger" class="item">文件大小：{{ formatSize(totalSize) }}</el-tag>
        </div>
        <div style="display: flex;width: 100%;justify-content: space-between;">
          <div style="width: 48%;">
            <el-table ref="multipleTable" :data="fileLists" tooltip-effect="dark" style="width: 100%" size="medium"
                      height="500" :header-cell-style="{ textAlign: 'center', background: '#f5f7fa' }"
                      :cell-style="{ textAlign: 'center' }" @selection-change="handleSelectionChange" border>
              <el-table-column prop="name" label="文件名"></el-table-column>
              <el-table-column prop="size" label="文件大小">
                <template slot-scope="scope">
                  {{ formatSize(scope.row.size) }}
                </template>
              </el-table-column>
              <el-table-column prop="name" label="状态">
                <template slot-scope="scope">
                  <div v-if="scope.row.num == 0">待上传</div>
                  <div v-else-if="scope.row.num == 100.00">已上传</div>
                  <div v-else>正在上传</div>
                  <!-- {{ scope.row.num == "0" ? "待上传" : "已上传" }} -->
                </template>
              </el-table-column>
              <el-table-column prop="name" label="进度">
                <template slot-scope="scope">
                  <el-progress :percentage="Math.floor(scope.row.num)"></el-progress>
                  <!-- {{ Math.floor(scope.row.num) }} -->
                </template>
              </el-table-column>
              <el-table-column label="操作">
                <template slot-scope="scope">
                  <el-button size="mini" type="danger" @click="handleDelete(scope.$index,scope)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div style="width: 48%;">
            <el-table ref="multipleTable" :data="YifileLists" tooltip-effect="dark" style="width: 100%" size="medium"
                      height="500" :header-cell-style="{ textAlign: 'center', background: '#f5f7fa' }"
                      :cell-style="{ textAlign: 'center' }" @selection-change="handleSelectionChange" border>
              <el-table-column prop="name" label="ID">
                <template slot-scope="scope">{{ scope.row.novel_id }}</template>
              </el-table-column>
              <el-table-column prop="name" label="文件名">
                <template slot-scope="scope">{{ scope.row.name }}</template>
              </el-table-column>
              <el-table-column prop="name" label="状态">
                <template slot-scope="scope">已上传</template>
              </el-table-column>
              <el-table-column prop="name" label="进度">
                <template slot-scope="scope">
                  <el-progress :percentage="100"></el-progress>
                </template>
              </el-table-column>

            </el-table>
          </div>

        </div>


      </div>
    </el-card>
  </div>
</template>

<script>
import {Session} from '@/utils/storage';
import {WorksListAPI} from '@/api/Works/WorksList';
import {UpdateAPI} from '@/api/Update/Update';
import {processErrors} from '@/utils/errorHandler';
import cos from '@/api/Update/cos';

export default {
  data() {
    return {
      fileLists: [],
      fileQueue: [],
      totalFiles: 0,
      uploadedFiles: 0,
      totalSize: 0,
      videoId: null,
      shownMessages: new Set(),
      YifileLists: [],
      YifileListsLength: 0,
      Videoepisode_total: 0,
      keySucces: "",
      showList: false,
      errdata: {},
      errdatas: [],
      videoName: "",
      errorData: {},
      timeout: null, // 用于存储 setTimeout 的 ID
      Bucket: 'novel-1327524272',
      Region: 'ap-beijing',
      Folders: ""
    };
  },
  computed: {
    formattedNum() {
      return Math.floor(this.row.num);
    }
  },
  created() {
    this.videoId = this.$route.query.id;

    this.videoName = this.$route.query.name;
    this.Videoepisode_total = this.$route.query.episode_total;

    if (process.env.NODE_ENV != 'production') {
      console.log("测试");
      this.Folders = "novel/" + this.videoId+'_develop' + "/"
    }else{
      console.log("正式");
      this.Folders = "novel/" + this.videoId + "/"
    }
    this.getYilist()
  },
  mounted() {
    this.errDatas = []
  },
  methods: {
    getYilist() {
      let api = WorksListAPI();
      api.VideoList(this.videoId).then((res) => {
        this.YifileLists = res.data
        this.YifileListsLength = res.data.length
        this.uploadedFiles = res.data.length
      })
    },

    async submitUpload() {
      console.log(this.fileLists,'fileLists')
      const uploadingFileIndexes = this.fileLists
          .map((item, index) => (item.num !== '0' ? index : -1))
          .filter(index => index !== -1);

      // 过滤出尚未上传的文件
      const newFilesToUpload = this.fileQueue.filter((file, index) => !uploadingFileIndexes.includes(index));

      // 如果没有新文件需要上传，直接返回
      if (newFilesToUpload.length === 0 && this.fileLists.length === 0) {
        this.$message({
          message: '没有新文件需要上传',
          type: 'warning'
        });
        return;
      }
      if (this.fileLists.length === 0) {
        this.$message({
          message: '没有新文件需要上传',
          type: 'warning'
        });
        return;
      }
      if (this.showList == true) {
        let errorOccurred = false;
        Session.get('geterrDatas').forEach(data => {
          const str = data.Key;
          const part = str.split('/').pop().split('.')[0];
         
          let params = {
            novel_id: this.videoId,
            resource: '/' + data.Key,
            name: part
          };
          console.log(params,'paramsparamsparamsparams')
          let api = UpdateAPI()
          api.getUpload(params).then(res => {
            if (res.code == 0) {
              let name = this.keySucces
              // this.fileLists = this.fileLists.filter(item => item.name !== name[1]);
              this.fileLists = this.fileLists.filter(item => item.num !== "100.00");
              this.getYilist()
            } else {
              if (!errorOccurred) {
                processErrors(res);
                errorOccurred = true;  // 设置标志，表示错误已经处理过
              }
              this.showList = true
            }

          })
        })
      }
      for (const file of newFilesToUpload) {
        await this.uploadFileWithResume(file);
      }
      this.$refs.upload.clearFiles();
    },

    async uploadFileWithResume(file) {
      const key = this.Folders + file.name;

      // 获取上次上传的进度（如果有）
      const uploadedParts = this.getUploadedParts(key);

      // 如果已经上传了部分文件，可以从上次的部分继续上传
      const startByte = uploadedParts.length * 20 * 1024 * 1024; // 每片大小5MB

      const uploadParams = {
        Bucket: this.Bucket,
        Region: this.Region,
        Key: key,
        SliceSize: 20 * 1024 * 1024, // 每片大小为5MB
        Body: file,
        onProgress: (progressData) => {
          // 计算当前文件的进度
          this.updateUploadProgress(key, progressData);
        },
        StartByte: startByte, // 从上次的断点开始
      };

      cos.sliceUploadFile(uploadParams, (err, data) => {
        if (err) {
          console.error('上传失败', err);
        } else {
          this.errDatas.push(data)
          Session.set('geterrDatas', this.errDatas);

          let name = data.Key.match(/-(.+)$/)
          this.keySucces = name
          this.updateUploadedParts(key, uploadedParts.length + 1); // 更新已上传的部分
          let api = UpdateAPI()
          const str = data.Key;
          const part = str.split('/').pop().split('.')[0];
          ;
          
          let params = {
            novel_id: this.videoId,
            resource: '/' + data.Key,
            name: part
          }
          console.log(params,'paramsparamsparamsparams')
          api.getUpload(params).then(res => {
            if (res.code == 0) {
              let name = this.keySucces
              this.fileLists = this.fileLists.filter(item => item.num !== "100.00");
              this.totalSize = this.calculateTotalSize(this.fileLists);
              this.totalFiles = this.fileLists.length
              this.getYilist()
            } else {
              processErrors(res);
              this.showList = true
            }

          })
        }
      });
    },

    // 获取文件已上传的分片信息（本地保存或从后端获取）
    getUploadedParts(key) {
      return JSON.parse(localStorage.getItem(`uploadedParts_${key}`)) || [];
    },

    // 更新上传进度
    updateUploadProgress(key, progressData) {
      console.log(progressData,'progressData')
      const progress = Number(progressData.loaded) / Number(progressData.total);
      console.log(progress,'progress')
      const fileName = key.split('/').pop();
      // 查找与文件名匹配的 fileInfo
      const fileInfo = this.fileLists.find(file => file.raw.name == (fileName));

      if (fileInfo) {
        fileInfo.num = (progress * 100).toFixed(2);  // 更新进度
        console.log(`文件 ${fileName} 上传进度: ${fileInfo.num}%`);
      } else {
      }
    },

    // 更新已上传的分片
    updateUploadedParts(key, partIndex) {
      const uploadedParts = this.getUploadedParts(key);
      uploadedParts.push(partIndex);
      localStorage.setItem(`uploadedParts_${key}`, JSON.stringify(uploadedParts));
    },

    handleChange(file, fileList) {
      const maxSize = 1024 * 1024 * 1024;
      if (file.raw.size > maxSize) {

        // 使用 this.$set 确保是响应式的
        if (!this.errorData[file.raw.name]) {
          this.$set(this.errorData, file.raw.name, []); // 确保是响应式的
        }

        // 向该文件的错误信息数组中添加新的错误消息
        this.errorData[file.raw.name].push(`文件 ${file.raw.name} 大小超过 1GB，无法上传。`);

        this.clearInvalidFiles(); // 清除不合法文件
        return;
      }
      // 检查文件名是否合法
      const match = file.name.match(/\d+/);
      const fileNumber = match ? parseInt(match[0], 10) : -1;
      const videoEpisodeTotal = Number(this.Videoepisode_total);
      if (fileNumber > videoEpisodeTotal) {

        // 使用 this.$set 确保是响应式的
        if (!this.errorData[file.raw.name]) {
          this.$set(this.errorData, file.raw.name, []); // 确保是响应式的
        }

        // 向该文件的错误信息数组中添加新的错误消息
        this.errorData[file.raw.name].push(`文件 ${file.name} 名称不合法，无法上传。`);

        this.clearInvalidFiles(); // 清除不合法文件
        return;
      }
      cos.multipartInit({
        Bucket: this.Bucket, // 填入您自己的存储桶，必须字段
        Region: this.Region,  // 存储桶所在地域，例如ap-beijing，必须字段
        Key: this.Folders + file.name,  // 存储在桶里的对象键（例如1.jpg，a/b/test.txt），必须字段
        Body: file.raw, // 必须，上传文件对象，可以是input[type="file"]标签选择本地文件后得到的file对象
      }, function (err, data) {
        if (data) {
          file.raw.uid = data.UploadId;
        } else {
          let errorData = {
            data: err.error.message,
            msg: err.error.message,
          }
          processErrors(errorData);
        }
      });

      // 检查文件是否已经存在于文件队列
      if (!this.fileQueue.some(f => f.name === file.name)) {
        this.fileQueue.push(file.raw);
      }

      const fileExistsInList = this.fileLists.some(existingItem => existingItem.raw.name === file.name);

      // 如果文件不存在，则添加到 fileLists 中
      if (!fileExistsInList) {
        this.fileLists.push({...file, num: `0`});
        this.totalFiles = this.fileLists.length;
        this.totalSize = this.calculateTotalSize(this.fileLists);
      } else {
        this.clearInvalidFiles();
      }
      // 遍历 fileList
      this.fileLists = this.fileLists.filter(item => item.raw.size < maxSize);
      this.fileQueue = this.fileQueue.filter(item => item.size < maxSize);
    },

    clearInvalidFiles() {
      // 清除 fileQueue 和 fileLists 中的无效文件
      this.fileQueue = this.fileQueue.filter(f => f.isValid !== false); // 假设你可以标记不合法的文件
      this.fileLists = this.fileLists.filter(f => f.isValid !== false); // 同上
    },

    calculateTotalSize(files) {
      return files.reduce((total, file) => total + file.size, 0);
    },

    // 计算文件大小（可选）
    formatSize(size) {
      const units = ['B', 'KB', 'MB', 'GB', 'TB'];
      let i = 0;
      while (size >= 1024 && i < units.length - 1) {
        size /= 1024;
        i++;
      }
      return `${size.toFixed(2)} ${units[i]}`;
    },

    handleSelectionChange(val) {
      this.multipleSelection = val
    },

    handleDelete(index, scope) {
      const keyToDelete = this.Folders + this.fileLists[index].raw.name;
      const keyToDeleteUid = this.fileLists[index].raw.uid;

      cos.multipartAbort({
        Bucket: this.Bucket,
        Region: this.Region,
        Key: keyToDelete,  // 存储在桶里的对象键
        UploadId: keyToDeleteUid    // 必须
      }, (err, data) => { // 使用箭头函数保持上下文
        if (data) {
          this.fileQueue.splice(index, 1);
          this.fileLists.splice(index, 1);
          this.totalFiles = this.fileLists.length;
          this.totalSize = this.calculateTotalSize(this.fileQueue);
        } else {
          let errorData = {
            data: err.error.message,
            msg: err.error.message,
          };
          processErrors(errorData);
        }
      });
    },

    submitBack() {
      this.$router.push({path: '/WorksManagement/worksList'});
    }
  },
  watch: {
    errorData: {
      handler(newValue, oldValue) {
        // 清除之前的定时器
        if (this.timeout) {
          clearTimeout(this.timeout);
        }

        // 设置新的定时器
        this.timeout = setTimeout(() => {
          let data = newValue;
          // 调用 processErrors 函数
          processErrors({data});
        }, 1000); // 1秒后执行
      },
      deep: true, // 深度监听，适用于对象或数组
    },
  },
}
</script>

<style scoped lang='scss'>
.upload-status {
  display: flex;
  margin-top: 10px;
  margin-bottom: 10px;

  .item {
    margin-left: 10px;
  }

}

.upload-title {
  margin-top: 20px;
  margin-bottom: 10px;
}

::v-deep .upload-demo .el-upload-dragger {
  width: 84vw;
  /* 默认宽度 */
}

@media (max-width: 1280px) {
  ::v-deep .upload-demo .el-upload-dragger {
    width: 77vw !important;
    /* 在小屏幕下设置为 77vw */
  }
}
</style>